import Blog from "../components/Sections/Blog";

export default function Home() {
  return (
      <>
          <Blog />

  
      </>
  )
  
}
